const TABLET_MIN_WIDTH = 768;
const DESKTOP_MIN_WIDTH = 1025;

export const getScreenType = (width) => {
  if (width < TABLET_MIN_WIDTH) return "mobile";
  if (width < DESKTOP_MIN_WIDTH) return "tablet";
  return "desktop";
};

export const getInitialScreenType = () =>
  typeof window === "undefined" ? "desktop" : getScreenType(window.innerWidth);
